// frontend/src/components/Samples/LineOpsBadges.jsx
//
// Renders a row of colored status badges for line operations.
// Used in SampleOrderArticleList to show per-line operation progress.

import React from 'react';
import { TASK_STATUS_META } from '../../constants/statusMeta';
import './LineOpsBadges.css';

// Extend base task statuses with the extra ones used by LineOperationsModal
const OP_STATUS_META = {
  ...TASK_STATUS_META,
  PENDING:  { label: 'Pendente',  cls: 'status--new',       color: '#3f6212', bg: '#ecfccb' },
  DONE:     { label: 'Feito',     cls: 'status--completed',  color: '#166534', bg: '#dcfce7' },
  BLOCKED:  { label: 'Bloqueado', cls: 'status--cancelled',  color: '#dc2626', bg: '#fee2e2' },
  N_A:      { label: 'N/A',       cls: 'status--on_hold',    color: '#6b7280', bg: '#f3f4f6' },
};

const fmt = (dateStr) => {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString();
};

const LineOpsBadges = ({ operations }) => {
  if (!operations || operations.length === 0) return <span className="lob-empty">—</span>;

  return (
    <div className="lob-row">
      {operations.map((op, i) => {
        const meta = OP_STATUS_META[op.status] || OP_STATUS_META.NEW;
        const tooltip = [
          `Tarefa: ${op.operation_label || '—'}`,
          `Responsável: ${op.assigned_user_name || '—'}`,
          `Fim Planeado: ${fmt(op.planned_end_date)}`,
          `Início Real:  ${fmt(op.real_start_date)}`,
          `Fim Real:     ${fmt(op.real_end_date)}`,
        ].join('\n');

        return (
          <div key={i} className="lob-item" title={tooltip}>
            <span
              className="lob-badge"
              style={{ background: meta.bg, color: meta.color, borderColor: meta.color }}
            >
              {op.operation_label}
            </span>
            <span className="lob-status-label" style={{ color: meta.color }}>
              {meta.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default LineOpsBadges;